import { agreementUrls, calendarLocales, languagesObject } from '../constants';

import type { TShortLanguageName } from '../types';

export const getLanguageFromLocale = () => {
  const languageCode = navigator.language.split('-')[0] as TShortLanguageName;

  let language: TShortLanguageName = 'en';

  if (Object.keys(languagesObject).includes(languageCode)) {
    language = languageCode;
  }

  return languagesObject[language];
};

export const getCalendarLocaleKey = () => {
  const language = getLanguageFromLocale();
  return calendarLocales[language];
};

export const getAgreementUrl = () => {
  const languageCode = navigator.language.split('-')[0] as TShortLanguageName;
  return agreementUrls[languageCode] || agreementUrls.en || 'https://info.quick-appointment.com/agreement_en.html';
};
